import { Grid, Input } from '@design-systems/canvas-ui'
import { SideNavigation } from '../globalComponents/SideNavigation'
import { useSearchParams } from 'react-router-dom'
import { PARAM_RETURNURL } from '../common/commonConstants'

export const LayoutPlaceholder = (props) => {
  const [searchParams] = useSearchParams()
  const returnUrl = searchParams.get(PARAM_RETURNURL)

  return (
    <Grid.Container
      spacing="none"
      className={
        props.isReadonly
          ? 'rfi-layout-shell rfi-layout-shell--readonly'
          : 'rfi-layout-shell'
      }
    >
      {/* Header Band */}
      {!props.isReadonly && (
        <Grid.Item size={{ xs: 12 }} className="rfi-layout-header hc8-pb-none">
          <div
            id="div-rfi-header"
            className="hc8-bg-inverse align-centre-centre"
          >
            <Input.Label className="hc8-fs-250 font-weight-500 hc8-mb-none hc8-clr-inverse">
              {props.headerText}
            </Input.Label>
          </div>
        </Grid.Item>
      )}

      <Grid.Item size={{ xs: 12 }} className="rfi-layout-body-item">
        <Grid.Container
          spacing="none"
          data-testid="mainLayoutPlaceholder"
          className="rfi-layout-body"
        >
          {props.showSideNav && (
            <Grid.Item
              size={{ xs: 12, md: 2 }}
              id="sideNav"
              className="rfi-layout-sidebar"
            >
              <SideNavigation
                returnUrl={returnUrl}
                isReadonly={props.isReadonly}
                userSettings={props.userSettings}
              />
            </Grid.Item>
          )}

          <Grid.Item
            size={{ xs: 12, md: props.showSideNav ? 10 : 12 }}
            className="rfi-layout-main"
          >
            <div className="rfi_scroll rfi-main-scroll">{props.component}</div>
          </Grid.Item>
        </Grid.Container>
      </Grid.Item>
    </Grid.Container>
  )
}
